<template>
  <transition name="modal">
    <div class="[ modal-mask ] absolute inset-0 overflow-hidden w-full h-full flex items-center justify-center"
      role="dialog"
      aria-labelledby="popupTitle"
      aria-describedby="popupDescription">

      <div class="[ modal-container ] rounded-md max-w-sm w-64 mx-3 my-4 p-0 bg-white shadow-sm transition-all duration-300 ease-in-out">

        <div class="modal-header px-3 py-2 bg-pink-200 rounded-t-md shadow-md" id="popupTitle">
          <slot name="header">
            default header slot
          </slot>
        </div>

        <div class="modal-body px-3" id="popupDescription">
          <slot name="body">
            default body slot
          </slot>
        </div>

        <div class="modal-footer p-0">
          <slot name="footer">
            <footer slot="footer" class="border-t my-2 px-3 py-2 w-full flex items-center justify-between">

              <button class="btn btn-close" @click="close()" aria-label="Close modal">Close</button>

            </footer>
          </slot>
        </div>

      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'Popup',
  props: {
    // type: confirm, (simple) notification
    mode: {
      type: String,
      required: false,
      default: 'confirm'
    }
  },
  computed: {
    showNotification: {
      get () { return this.$store.state.rootNotification },
      set (bool) { this.$store.state.rootNotification = bool }
    },
    notificationMsg: {
      get () { return this.$store.state.rootNotificationMsg },
      set (str) { this.$store.state.rootNotificationMsg = str }
    }
  },
  methods: {
    close () {
      // console.log('close in Popup invoked')
      this.showNotification = false
      this.notificationMsg = ''
      this.$emit('close')
    }
  }
}
</script>

<style lang="postcss" scoped>
.modal-mask {
  z-index: 999998;
  background-color: rgba(0, 0, 0, 0.5);
  transition: opacity 0.3s ease;
  @apply rounded-t-md;
}

.modal-header h3 {
  margin-top: 0;
}

.modal-body {
  margin: 20px 0;
}

.modal-default-button {
  float: right;
}

.btn-close {
  @apply text-pink-800 hover:bg-pink-700 hover:text-pink-200 transition-colors leading-none ml-auto mr-0;
}

/*
 * The following styles are auto-applied to elements with
 * transition="modal" when their visibility is toggled
 * by Vue.js.
 *
 * You can easily play with the modal transition by editing
 * these styles.
 */

.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}

</style>
